import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './BannerPage.module.css';
import Loader from '../../components/Loader/Loader';
import { useNavMenuStore } from '../../store/useNavMenuStore';

interface BannerData {
  id: number;
  title: string;
  about: string;
  text: string;
  photo_url: string;
  position: number;
  status: string;
  created_at: string;
}

const BannerPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state as { banner?: BannerData } | undefined;
  const [isLoading, setIsLoading] = useState(true);
  const banner: BannerData | null = locationState?.banner ?? null;
  const { setVisibility: setNavMenuVisibility } = useNavMenuStore();

  useEffect(() => {
    setNavMenuVisibility(false);
  }, [setNavMenuVisibility]);

  useEffect(() => {
    return () => {
      setNavMenuVisibility(true);
    };
  }, [setNavMenuVisibility]);

  useEffect(() => {
    if (!banner) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    const loadingStartTime = Date.now();
    const img = new Image();

    img.onload = () => {
      const minLoadingTime = 1000;
      const elapsedTime = Date.now() - loadingStartTime;
      const remainingTime = Math.max(0, minLoadingTime - elapsedTime);

      setTimeout(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      }, remainingTime);
    };

    img.onerror = () => {
      if (!cancelled) {
        setIsLoading(false);
      }
    };

    img.src = banner.photo_url;

    return () => {
      cancelled = true;
    };
  }, [banner]);

  if (isLoading) {
    return <Loader />;
  }

  if (!banner) {
    return (
      <div className={styles.container}>
        <div className={styles.page}>
          <button
            className={styles.backButton}
            onClick={() => navigate('/catalog')}
            type="button"
          >
            ← Назад
          </button>
          <div className={styles.emptyState}>Баннер не найден</div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.page}>
        <button
          className={styles.backButton}
          onClick={() => navigate('/catalog')}
          type="button"
        >
          ← Назад
        </button>

        <div className={styles.bannerImageWrap}>
          <img className={styles.bannerImage} src={banner.photo_url} alt={banner.title} />
        </div>

        <div className={styles.textContent}>
          <h1 className={styles.bannerTitle}>{banner.title}</h1>
          <div
            className={styles.bannerDescription}
            dangerouslySetInnerHTML={{
              __html: banner.text.replace(/<br>/g, '<br/>'),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BannerPage;
